import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useAffiliates() {
  const [loading, setLoading] = useState(true);
  const [affiliates, setAffiliates] = useState(null);

  useEffect(() => {
    axios
      .get(routes.api.affiliates.index)
      .then((response) => {
        setAffiliates(response.data.data);
        setLoading(false);
      });
  }, []);

  return { loading, affiliates };
}
